/**
 * Converts a value to an integer if it is of type string.
 * If the value is already a number, it returns it as is.
 * If the value cannot be converted to a number, it throws an error.
 *
 * @param {string|number} value - The value to be converted.
 * @returns {number} - The value converted to an integer.
 * @throws {Error} - Throws an error if the value is not a valid number or is not a string/number.
 */
export const convertToInteger = (value) => {
  if (typeof value === "string") {
    const parsedValue = parseInt(value, 10);

    if (!isNaN(parsedValue)) {
      return parsedValue; // Return the converted number
    } else {
      throw new Error("The value is not a valid number.");
    }
  }

  if (typeof value === "number") {
    return value;
  }

  throw new Error("The value is neither a string nor a number.");
};

const decodeJWT = (token) => {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};

export const getGuestUserId = () => {
  const guestToken = localStorage.getItem("guest");
  if (guestToken) {
    const decoded = decodeJWT(guestToken);
    return decoded?.id ? `auth0|${decoded.id}` : "";
  }
  return "";
};

export const getGuestUserName = () => {
  const guestToken = localStorage.getItem("guest");
  if (guestToken) {
    const decoded = decodeJWT(guestToken);
    return decoded?.name ? decoded.name : "";
  }
  return "";
};

export const getUserAsQParam = (id, value="&") => {
  if (id && id!=="") {
    return `${value}id_user=${id}`;
  }
  return "";
};
